import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {CSS_CONSTANTS} from '../../css_variables';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const BugIcon = ({size, color, onClick, intl, shouldShow}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '11';
			case SIZE.STANDARD:
				return '13';
			default:
				return '14';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '14';
			case SIZE.STANDARD:
				return '16';
			default:
				return '16';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<StyledSpan
			onClick={handleClick}
			width={getWidth(size)}
			height={getHeight(size)}
			title={intl.formatMessage({id: 'common.bug'})}
			shouldShow={shouldShow}
		>
			<svg xmlns="http://www.w3.org/2000/svg" width={getWidth(size)} height={getHeight(size)} viewBox="0 0 16 16">
				<path
					fill={color}
					fillRule="evenodd"
					d="M8 12.8c-2.22 0-4-1.88-4-4 0-2.206 1.794-4 4-4s4 1.794 4 4c0 2.122-1.78 4-4 4zM7.2 2.4c0-.44.36-.8.8-.8.44 0 .8.36.8.8 0 .44-.36.8-.8.8-.44 0-.8-.36-.8-.8zm8.8 4h-2.948a5.927 5.927 0 0 0-.21-.4L15.2 4.428V1.6h-1.6v1.972l-1.754 1.169a5.599 5.599 0 0 0-1.78-1.141c.207-.354.334-.76.334-1.2C10.4 1.077 9.323 0 8 0a2.403 2.403 0 0 0-2.4 2.4c0 .44.127.846.334 1.2a5.599 5.599 0 0 0-1.78 1.14L2.4 3.573V1.6H.8v2.828L3.158 6c-.076.13-.144.264-.21.4H0V8h2.464a5.62 5.62 0 0 0-.064.8c0 .272.026.538.064.8H0v1.6h2.948c.077.16.16.317.252.469l-1.6 1.6V16h1.6v-2.069l1.016-1.015a5.57 5.57 0 0 0 7.568 0l1.016 1.015V16h1.6v-2.731l-1.6-1.6c.091-.152.175-.308.252-.469H16V9.6h-2.464c.038-.262.064-.528.064-.8a5.62 5.62 0 0 0-.064-.8H16V6.4z"
				/>
			</svg>
		</StyledSpan>
	);
};

BugIcon.SIZE = SIZE;
BugIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string,
	shouldShow: PropTypes.bool,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
	intl: PropTypes.shape({
		formatMessage: PropTypes.func,
	}),
};

BugIcon.defaultProps = {
	color: CSS_CONSTANTS.v2_text_gray,
	intl: {
		formatMessage: ({id}) => id,
	},
};

export const StyledSpan = Styled.span`
	display: ${props => (props.shouldShow ? 'inline' : 'none')}; // Dirty hack for google translate
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	svg{
		vertical-align:text-top;
	}
`;
